import styled from 'react-emotion';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

import Chip from '@material-ui/core/Chip';
import Cancel from '@material-ui/icons/Cancel';

const blackOverlay = (opacity) => `
    content: " ";
    z-index: 10;
    display: block;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    background-color: ${colors.blackAlpha(opacity)};
    border-radius: 18px;
`;

export const UserChip = styled(Chip)`
  cursor: pointer;
  background-color: white;
  border: 1px solid ${colors.blackAlpha(0.12)};
  flex-shrink: 0;
  border-radius: 18px;
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  color: ${colors.designSystem.blackOpacity87};
  position: relative;

  &:hover {
    background-color: ${colors.designSystem.background.grey.hover};
  }

  &.notEducatorWarning {
    background-color: ${colors.designSystem.background.light.warning};
  }

  &.notEducatorWarning:hover::after {
    ${blackOverlay(theme.opacity.alpha4)}
  }

  &.notEducatorWarning:focus {
    border: 1px solid ${colors.designSystem.blackOpacity87};
  }

  &.notEducatorWarning:focus::after {
    ${blackOverlay(0.14)}
  }

  &.notEducatorWarning:active::after {
    ${blackOverlay(0.1)}
  }

  & > svg {
    z-index: 100000000000;
  }
`;

export const CancelIcon = styled(Cancel)`
  color: ${colors.designSystem.blackOpacity60};
  font-size: 20px;
`;
